import React from "react";
import { comparer, toJS } from "mobx";
import { observer } from "mobx-react-lite";
import { useFormContext } from "../Form";
import { createUseStyles } from "react-jss";
export var SelectTableRowCheckbox = observer(function (_a) {
    var id = _a.id, label = _a.label, name = _a.name, _b = _a.invert, invert = _b === void 0 ? false : _b;
    var values = useFormContext().values;
    var handleChange = React.useCallback(function (e) {
        var collection = toJS(values.get(name)) || [];
        if ((e.target.checked && !invert) || (!e.target.checked && invert)) {
            collection.push(id);
        }
        else {
            collection = collection.filter(function (item) { return item !== id; });
        }
        values.set(name, collection);
    }, [values, name, id, invert]);
    var getValue = values
        .get(name)
        .find(function (item) { return comparer.structural(item, id); });
    var getChecked = function () { return (invert ? !getValue : !!getValue); };
    var classes = useCheckboxLabelClasses();
    return (React.createElement("label", { className: classes.label },
        React.createElement("input", { name: id, id: id, type: "checkbox", onChange: handleChange, checked: getChecked() }),
        React.createElement("span", { className: "sr-only" }, label)));
});
var useCheckboxLabelClasses = createUseStyles({
    label: {
        width: 30,
        paddingLeft: 9,
        paddingTop: 7,
        paddingBottom: 3,
        marginBottom: "0px !important",
    },
});
